import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a product price.
 * This component listens for variant update events and updates the price display accordingly.
 * It handles price updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class PromoMessage extends HTMLElement {
    connectedCallback() {
        const closestSection = this.closest('.shopify-section, dialog');
        if (!closestSection) return;
        closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePromoMessage);
    }

    disconnectedCallback() {
        const closestSection = this.closest('.shopify-section, dialog');
        if (!closestSection) return;
        closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePromoMessage);
    }

    /**
     * Updates the final sale message and line item property.
     * @param {VariantUpdateEvent} event - The variant update event.
     */
    updatePromoMessage = (event) => {
        if (event.detail.data.newProduct) {
            this.dataset.productId = event.detail.data.newProduct.id;
        } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
            return;
        }

        const newPromoMessage = event.detail.data.html.querySelector('promo-message [ref="promoMessageContainer"]');
        const currentPromoMessage = this.querySelector('[ref="promoMessageContainer"]');
        if (!newPromoMessage || !currentPromoMessage) return;

        if (currentPromoMessage.innerHTML !== newPromoMessage.innerHTML) {
            currentPromoMessage.replaceWith(newPromoMessage);
        }
    };
}

if (!customElements.get('promo-message')) {
    customElements.define('promo-message', PromoMessage);
}
